import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.max-safe-integer";
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
export default MAX_SAFE_INTEGER;